import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import { Watch } from "vue-property-decorator";

@Component({ name: "TrainingFilter" })
export default class TrainingFilter extends Vue {
    public localizer: any = Localizer;
    public filterData: any = null;
    public formData: any = {};
    public isShowFilters: boolean = false;

    get routes() {
        return (<any>window).App.routes;
    }

    get isFilterVisible() {
        return this.$store.getters["myMectronicTrainingStore/isFilterVisible"];
    }

    @Watch("isFilterVisible") onFilterVisibilityUpdate(newValue: boolean) {
        const vm = this;
        if (newValue) {
            (<any>this).$refs.form.classList.add("show");
        } else {
            (<any>this).$refs.form.classList.remove("show");
        }
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.filterData = (await Axios.post(this.routes.MyMectronicTraining_GetFilterData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

        this.formData.searchText = <string>this.$route.query.searchText != null ? <string>this.$route.query.searchText : null;
        this.formData.type = <string>this.$route.query.type != null ? <string>this.$route.query.type : null;
        this.formData.isregistered = <string>this.$route.query.isregistered != null ? <string>this.$route.query.isregistered : null;
    }

    public async submitForm() {
        this.checkFormData();

        var url = new URL(window.location.origin + window.location.pathname);
        if (this.formData.searchText) {
            url.searchParams.set('searchText', this.formData.searchText);
        }
        if (this.formData.type) {
            url.searchParams.set('type', this.formData.type);
        }
        if (this.formData.isregistered) {
            url.searchParams.set('isregistered', this.formData.isregistered);
        }

        window.location.href = url.href;
    }

    public checkFormData() {
        if (this.formData.searchText === "") {
            this.formData.searchText = null;
        }
    }

    public resetFilters() {
        this.formData = {};

        this.submitForm();
    }
};